import React from 'react';
import './ExpiryTicker.css';

const ExpiryTicker = ({ expiryData }) => {
  // Map data to meaningful messages
  const messages = [];

  if (expiryData.document > 0) {
    messages.push(`${expiryData.document} document${expiryData.document > 1 ? 's' : ''} have expired`);
  }
  if (expiryData.salary > 0) {
    messages.push(`${expiryData.salary} pending salar${expiryData.salary > 1 ? 'ies' : 'y'}`);
  }
  if (expiryData.products > 0) {
    messages.push(`${expiryData.products} product${expiryData.products > 1 ? 's' : ''} have expired`);
  }

  if (messages.length === 0) return null;

  const combinedMessage = messages.map(msg => ` 🔴 ${msg}`).join('\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0');

  return (
    <div className="expiry-ticker-container">
      <div className="expiry-ticker-text">
        {combinedMessage}
      </div>
    </div>
  );
};

export default ExpiryTicker;